import { DataSource } from "@angular/cdk/collections";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { retry } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CountriesCurrenciesService {
  constructor(private http: HttpClient) {}

  // Cultures
  public getAllCultures() {
    return this.http.get("/General/GetAllCulture");
  }
  public getCurrenciesAndCultures() {
    return this.http.get("/currency/get-all-currencies");
  }
  public getUsedCulturs() {
    return this.http.get("/currency/get-used-cultures");
  }
  public getSiteCalture(status: number) {
    return this.http.get(`/Sites/GetUsedSiteCulturesByStatus/${status}`);
  }
  public addCulture(newCulture) {
    return this.http.post("/culture/AddCulture", newCulture);
  }
  public deleteCulture(id) {
    return this.http.delete("/culture/removeCulture/" + id);
  }
  public getCultures() {
    return this.http.post("/Culture/GetAllCultures", {});
  }
  // Currencies
  public getCurrencies(param) {
    return this.http.post("/currency/get-currencies-grid", param);
  }
  public getCurrencyById(id) {
    return this.http.get("/currency/getCurrencyById/" + id);
  }
  public deleteCurrency(id) {
    return this.http.delete("/currency/delete-currency/" + id);
  }
  public addCurrency(currency) {
    return this.http.post("/currency/add-currency", currency);
  }
  public editCurrency(currency) {
    return this.http.post("/currency/edit-currency", currency);
  }
  // Countries
  public getCountriessDDL() {
    return this.http.get("/countries/get-all-countries");
  }
  public getUsedCountries() {
    return this.http.get("/countries/GetFilterdCountries");
  }
  public getCountries(param?) {
    return this.http.post("/countries/grid", param);
  }
  public getCountryById(id) {
    return this.http.get("/countries/" + id);
  }
  public addCountry(country) {
    return this.http.post("/countries", country);
  }
  public editCountry(id, country) {
    return this.http.put("/countries/" + id, country);
  }
  public deleteCountryById(id) {
    return this.http.delete("/countries/" + id);
  }
  //States
  public getStates(countryId, param) {
    return this.http.post(
      "/states-provinces/grid?countryId=" + countryId,
      param
    );
  }
  public getStatesDDL(countryId) {
    return this.http.get("/states-provinces/states?countryId=" + countryId);
  }
  public getStateById(id) {
    return this.http.get("/states-provinces/" + id);
  }
  public addState(state) {
    return this.http.post("/states-provinces", state);
  }
  public editState(id, state) {
    return this.http.put("/states-provinces/" + id, state);
  }
  public deleteStateById(id) {
    return this.http.delete("/states-provinces/" + id);
  }
  //Districts
  public getDistricts(stateId, params) {
    return this.http.post("/districts/grid?stateId=" + stateId, params);
  }
  public getDistrictById(id) {
    return this.http.get("/districts/" + id);
  }
  public addDistrict(district) {
    return this.http.post("/districts", district);
  }
  public editDistrict(id, district) {
    return this.http.put("/districts/" + id, district);
  }
  public deleteDistrict(id) {
    return this.http.delete("/districts/" + id);
  }
  editCulture(data){
return this.http.patch("/culture/UpdateCulture",data)
  }
}
